// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { invProductionId } from './InvProduction';
import { invQuantityUnitEnum } from './InvQuantityUnitEnum';
import { invRecipeStepId } from './InvRecipeStep';
import { z } from 'zod';
export const invProductionComponentId = (z.number());
export const invProductionComponent = z.object({
    id: invProductionComponentId,
    production_id: invProductionId,
    consumed_item_id: z.number().transform((val) => val),
    consumed_quantity: z.number(),
    consumed_quantity_unit: invQuantityUnitEnum,
    recipe_step_id: invRecipeStepId.nullable(),
    additive: z.boolean(),
    ml_per_kg: z.string().nullable(),
});
export const invProductionComponentInitializer = z.object({
    id: invProductionComponentId.optional(),
    production_id: invProductionId,
    consumed_item_id: z.number().transform((val) => val),
    consumed_quantity: z.number(),
    consumed_quantity_unit: invQuantityUnitEnum,
    recipe_step_id: invRecipeStepId.optional().nullable(),
    additive: z.boolean().optional(),
    ml_per_kg: z.string().optional().nullable(),
});
export const invProductionComponentMutator = z.object({
    id: invProductionComponentId.optional(),
    production_id: invProductionId.optional(),
    consumed_item_id: z.number().transform((val) => val).optional(),
    consumed_quantity: z.number().optional(),
    consumed_quantity_unit: invQuantityUnitEnum.optional(),
    recipe_step_id: invRecipeStepId.optional().nullable(),
    additive: z.boolean().optional(),
    ml_per_kg: z.string().optional().nullable(),
});
//# sourceMappingURL=InvProductionComponent.js.map